import React from "react";

import dogImage from "../assets/img/dogs/dog-contact.png";

const Contact = () => {
  return (
    <section className="bg-yellow-secondary pt-6">
      <div className="container mx-auto ">
        <div className="flex flex-col lg:flex-row justify-around">
          <div className="order-1 lg:-order-1 lg:mt-16">
            <img src={dogImage} alt="Dog" className="-mb-[12px]" />
          </div>

          <div className="flex flex-col items-center justify-center">
            <div className="text-orange font-semibold mb-3">Contato</div>
            <div className="lg:text-4xl md:text-3xl text-blue font-extrabold mb-6">inclusivepet@email.com</div>
            <button className="btn">Fale conosco</button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
